import { useAuthUser } from 'features/user'
import { UsePriceGeniusAlwaysOn } from './types'

export const usePriceGeniusAlwaysOn = (): UsePriceGeniusAlwaysOn => {
  const {
    user: { currentWorkspace },
  } = useAuthUser()

  if (!currentWorkspace) {
    throw new Error('Current Workspace should be accessible')
  }

  const { priceGeniusAlwaysOn } = currentWorkspace

  const overwritePriceGeniusState: UsePriceGeniusAlwaysOn['overwritePriceGeniusState'] = (
    product,
  ): boolean => priceGeniusAlwaysOn && product === 'priceGenius'

  return {
    overwritePriceGeniusState,
    priceGeniusAlwaysOn,
  }
}
